<template>
    <b-modal
        id="combined-archived-personal-goals-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        size="lg"
        title="Geschiedenis leerdoelen"
        ok-only
        :ok-title="$t('common.close')"
        ok-variant="primary">
        <design2021-apprentice-data-table
            :items="personalGoalsIn"
            :fields="fields"
            show-empty>
            <template #cell(actions)="row">
                <div
                    class="management-actions"
                    v-if="row.item.grades.length">
                    <b-button
                        class="btn-line-graph btn-show-graph"
                        variant="primary-icon-only"
                        @click="showChart(row.item)">
                    </b-button>
                </div>
            </template>

            <template #empty>
                <div class="not-found with-header">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">Er zijn geen leerdoelen gevonden.</div>
                </div>
            </template>
        </design2021-apprentice-data-table>

        <design-2021-combined-personal-goal-chart-component ref="personGoalAreaChart">
        </design-2021-combined-personal-goal-chart-component>
    </b-modal>
</template>

<script>
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-combined-history-personal-goals-modal-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        personalGoalsIn: {
            type: Array,
            required: false,
            default: [],
        },
    },
    data() {
        return {
            modal: false,
            fields: [
                {
                    key: 'name',
                    label: 'Leerdoelen',
                },

                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        show() {
            this.modal = true;
        },

        showChart(personalGoal) {
            const data = {
                title: personalGoal.name,
                seriesName: 'Beoordeling',
                seriesData: personalGoal.grades.map((grade) => {
                    switch (grade.grade) {
                        case 'Onvoldoende':
                            return 25;
                        case 'Matig':
                            return 50;
                        case 'Voldoende':
                            return 75;
                        case 'Goed':
                            return 100;
                    }
                }),
                xAxisCategories: personalGoal.grades.map((grade) => grade.created_at),
            };

            this.$refs.personGoalAreaChart.show(data);
        },
    },
};
</script>

<style scoped lang="scss"></style>
